export const myOrderHe = {
  "refresh failed": "הפעולה הצליחה, אך לא ניתן לרענן את הרשימה. טענו מחדש את העמוד.",
  "action failed": "לא ניתן לבצע את הפעולה. נסו שוב.",
  "action loading": "טוען הזמנה…",
  "action updating": "מעדכן הזמנה…",
  "action updated": "ההזמנה עודכנה בהצלחה",
  "preview failed": "לא ניתן לטעון את התצוגה המקדימה של ההזמנה. נסו שוב.",
  "duplicate failed": "לא ניתן לשכפל את ההזמנה. נסו שוב.",
  "duplicate loading": "משכפל הזמנה…",

  "completed": "הושלם",
  "order edited by supplier": "ההזמנה נערכה על ידי הספק",
  "orders created": "הזמנות שנוצרו",
  "this week": "השבוע",
  "sites delivery": "אתרים מחכים למשלוח",
  "for this week": "בשבוע הקרוב",
  "no delivery": "ללא משלוח",

  "my order": "ההזמנות שלי",
  "create order": "יצירת הזמנה חדשה",
  "date order create": "תאריך יצירת ההזמנה",
  order: "שם ההזמנה",
  "order no": "מספר הזמנה",
  site: "אתר",
  "total weight": " סה״כ משקל (טון)",
  "Order Status": "סטטוס",
  "delivery date": "תאריך משלוח",
  "next delivery": "תאריך אספקה מבוקש",
  "quantity of orders": "כמות הזמנות",
  "total weights": "סה״כ משקל",
  "add new": "הוסף",
  weight: "משקל",

  "my sites": "האתרים שלי",
  "add new site": "הוסף אתר חדש",
  "site name": "שם אתר",
  address: "כתובת",
  "site manager": "מנהל עבודה",
  "site man": "עובד באתר",
  "contact on site": "איש קשר באתר",

  contact: "איש קשר",
  "add new contact": "הוסף איש קשר חדש",
  contacts: "אנשי קשר",
  name: "שם",

  "phone number": "טלפון",
  "job title": "תפקיד",
  "create new contact": "צור איש קשר חדש",
  "contact details": "פרטי איש קשר",
  "required fields": "שדות חובה",
  "delete this contact": "מחק איש קשר",

  "supplier orders title": "ההזמנות שלי",
  "supplier customers title": "הלקוחות שלי",
  "supplier order search": "חיפוש לפי מספר הזמנה, שם או לקוח...",
  "supplier customer search": "חיפוש לפי שם, ח.פ או איש קשר...",

  "customer filter all": "לקוח: הכל",
  "project filter all": "אתרים: הכל",
  "sort delivery date": "מיון: תאריך משלוח",
  "sort oldest first": "תאריך משלוח: מהישן לחדש",
  "sort newest first": "תאריך משלוח: מהחדש לישן",
  "new supplier order": "הזמנה חדשה",

  "supplier created date": "תאריך יצירת הזמנה",
  "supplier order number": "מספר הזמנה",
  "supplier order name": "שם ההזמנה",
  "supplier customer": "לקוח",
  "supplier status": "סטטוס",
  "supplier site": "אתר",
  "supplier total weight": "סה״כ משקל (טון)",
  "supplier delivery date": "תאריך משלוח",
  "open supplier order": "פתיחת הזמנה",
  "no supplier orders": "לא נמצאו הזמנות",

  "update order status": "עדכון סטטוס הזמנה",
  "supplier status NEW": "הזמנה חדשה",
  "supplier status QUOTE": "הצעת מחיר",
  "supplier status IN_PRODUCTION": "בייצור",
  "supplier status SENT": "נשלחה",

  "customer status all": "סטטוס: הכל",
  "activity filter all": "מיון: הזמנות פעילות",
  "activity filter active": "עם הזמנות פעילות",
  "activity filter none": "ללא הזמנות פעילות",
  "add supplier customer": "הוסף לקוח",

  "supplier customer name": "שם הלקוח",
  "supplier business number": "ח.פ",
  "supplier contact person": "איש קשר",
  "supplier phone": "טלפון",
  "supplier active orders": "הזמנות פעילות",
  "supplier customer status": "סטטוס",
  "supplier actions": "פעולות",
  "active orders count": "פעילות",

  "customer status ACTIVE": "פעיל",
  "customer status NEW": "חדש",
  "customer status INACTIVE": "לא פעיל",

  "supplier email action": "מייל",
  "no supplier customers": "לא נמצאו לקוחות",

  "add customer modal title": "הוספת לקוח חדש",
  "add customer modal subtitle": "מלא/י את פרטי הלקוח",
  "supplier customer name placeholder": "שם החברה",
  "supplier business number placeholder": "מספר מזהה",
  "supplier contact placeholder": "שם איש הקשר",
  "supplier email": "אימייל",
  "supplier address": "כתובת",
  "supplier address placeholder": "רחוב, עיר",
  "supplier cancel": "ביטול",
  "supplier add customer submit": "הוסף לקוח",

  "active orders modal title": "הזמנות פעילות · {{customer}}",
  "active orders modal count": "הזמנות פעילות",
  "supplier order": "הזמנה",
  "supplier ton": "טון",
  "no active customer orders": "אין הזמנות פעילות",
  "view all customer orders": "צפייה בכל הזמנות הלקוח",

  "view customer details": "פרטי לקוח",
  "edit customer": "עריכת לקוח",
  "delete customer": "מחיקת לקוח",
  "delete customer confirm": "האם למחוק את הלקוח?",
  "edit customer details": "עריכת פרטים",

  "customer active orders statistic": "הזמנות פעילות",
  "customer total orders statistic": "סה״כ הזמנות",
  "customer total tons statistic": "סה״כ טון",

  "customer contacts title": "אנשי קשר",
  "add customer contact": "הוסף איש קשר",
  "contact name": "שם",
  "contact role": "תפקיד",
  "delete contact confirm": "האם למחוק את איש הקשר?",
  "supplier save": "שמור",

  "customer orders title": "הזמנות",
  "showing customer orders": "מציג {{shown}} מתוך {{total}}",
  "edit customer modal title": "עריכת לקוח",
  "edit customer modal subtitle": "עדכון פרטי הלקוח",
  "supplier update customer submit": "שמור שינויים",

  "copy order number": "העתקת מספר הזמנה",
  "order number copied": "מספר ההזמנה הועתק",
  "change order status": "שינוי סטטוס הזמנה",
  "open order details": "פתיחת פרטי הזמנה",
  "show active orders": "הצגת הזמנות פעילות",
  "send customer email": "שליחת מייל ללקוח",
  "open customer actions": "פתיחת פעולות לקוח",
  "close window": "סגירת חלון",
  "select customer": "בחר לקוח",

  "expand details": "הצגת פרטים",
  "collapse details": "סגירת פרטים",
  "customer details": "פרטי לקוח",
  "update customer status": "עדכון סטטוס לקוח",
  "no filter results": "לא נמצאו תוצאות",
  "order actions": "פעולות הזמנה",
  "incoming order edit warning":
  "שים לב, אתה עומד לבצע עריכה בהזמנה של הלקוח. מומלץ ליידע את הלקוח בשינויים.",
  "incoming order edit warning title": "עריכת הזמנת לקוח",
  "cancel edit": "ביטול",
  "continue to edit": "המשך לעריכה",
  "approve incoming order": "אישור",
  "decline incoming order": "דחייה",
  "supplier status": "סטטוס",
  "supplier status NEW": "הזמנה חדשה",
  "supplier status QUOTE": "הצעת מחיר",
  "supplier status IN_PRODUCTION": "בייצור",
  "supplier status SENT": "נשלחה",

  "approve incoming order": "אישור",
  "decline incoming order": "דחייה",
  "incoming order waiting": "ממתינה לטיפול",
  "edit contact": "עריכת איש קשר",
  "delete contact": "מחיקת איש קשר",
  "select site": "בחר אתר",
};
